import { AccountAppLogin } from '@/service';

/**
 * @class @name AppLogin
 * @description Exposes app login store module
 */
export default class AppLogin {
	/**
	 * @method @static @get @name namespaced
	 * @description Is this module namespaced?
	 */
	static get namespaced() {
		return true;
	}

	/**
	 * @method @static @get @name state
	 * @description Expose state as an object, compatible with vue stores
	 */
	static get state() {
		return {};
	}

	/**
	 * @method @static @get @name getters
	 * @description Expose getters as an object, compatible with vue stores
	 */
	static get getters() {
		return {};
	}

	/**
	 * @method @static @get @name mutations
	 * @description Expose mutations as an object, compatible with vue stores
	 */
	static get mutations() {
		return {};
	}

	/**
	 * @method @static @get @name actions
	 * @description Expose action as an object, compatible with vue stores
	 */
	static get actions() {
		return {
			/**
			 * @async @name createAppLoginSession
			 * @description open an app login session for the current user, or pick up the running one
			 * @param {function} store
			 * @param {Object} payload
			 */
			async createAppLoginSession(store, payload) {
				return AccountAppLogin.post(payload);
			}
		};
	}
}
